import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../ui/section-titles/SectionTitle";

const BlogGridOne = () => {
  return (
    <div className="dg__blog__are bg--white pb--140">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            {/* section title */}
            <SectionTitle
              title="Our Latest News"
              text="Tipping-Token is now in more than 2000 hotel and restaurants worldwide."
            />
          </div>
        </div>
        <div className="row">
          {/* Start Single Blog */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <article className="blog">
              <div className="thumb">
                <Link to={process.env.PUBLIC_URL + "/blog-post"}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/blog/list/news.jpg"}
                    alt="blog images"
                  />
                </Link>
              </div>
              <div className="content">
                <span>Progress</span>
                <h2>
                  <Link to={process.env.PUBLIC_URL + "/blog-post"}>
                  Solving three problems facing service industries – the disappearance of cash, the growing demand for contactless solutions and changing culture to attract and retain talent.
                  </Link>
                </h2>
                <p>February 13, 2020</p>
              </div>
            </article>
          </div>
          {/* End Single Blog */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            {/* Start Single Blog */}
            <article className="blog blog__small">
              <div className="thumb">
                <Link to={process.env.PUBLIC_URL + "/blog-post"}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/blog/list/news3.jpg"}
                    alt="blog images"
                  />
                </Link>
              </div>
              <div className="content">
                <span>Progress</span>
                <h2>
                  <Link to={process.env.PUBLIC_URL + "/blog-post"}>
                  Simple, fast digital tipping solution for an evolving cashless economy.
                  </Link>
                </h2>
                <p>February 13, 2020</p>
              </div>
            </article>
            {/* End Single Blog */}
            {/* Start Single Blog */}
            <article className="blog blog__small">
              <div className="thumb">
                <Link to={process.env.PUBLIC_URL + "/blog-post"}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/blog/list/news2.jpg"}
                    alt="blog images" 
                  />
                </Link>
              </div>
              <div className="content">
                <span>Progress</span>
                <h2>
                  <Link to={process.env.PUBLIC_URL + "/blog-post"}>
                  The best solution through covid-19 crisis.
                  </Link>
                </h2>
                <p>February 13, 2020</p>
              </div>
            </article>
            {/* End Single Blog */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogGridOne;
